let clickHandlers = new Map();

const handleFooterDropdown = () => {
	const dropWrappers = document.querySelectorAll('.mm-footer-dropdown-trigger');
	const isMobile = window.innerWidth <= 768;

	dropWrappers.forEach((item) => {
		// Supprimer l'ancien listener s'il existe
		if (clickHandlers.has(item)) {
			item.removeEventListener("click", clickHandlers.get(item));
			clickHandlers.delete(item);
		}

		// Ajouter le listener seulement si on est en mobile
		if (isMobile) {
			const handler = function () {
				dropWrappers.forEach((el) => {
					if (el !== this) {
						el.classList.remove("active");
						const otherContent = el.nextElementSibling;
						if (otherContent && otherContent.classList.contains('mm-footer-dropdown-content')) {
							otherContent.style.maxHeight = null;
						}
					}
				});

				this.classList.toggle("active");
				const content = this.nextElementSibling;

				if (content && content.classList.contains('mm-footer-dropdown-content')) {
					if (this.classList.contains("active")) {
						content.style.maxHeight = `${content.scrollHeight}px`;
					} else {
						content.style.maxHeight = null;
					}
				}
			};

			item.addEventListener("click", handler);
			clickHandlers.set(item, handler);
		} else {
			// En desktop, réinitialiser l'état
			item.classList.remove("active");
			const content = item.nextElementSibling;
			if (content && content.classList.contains('mm-footer-dropdown-content')) {
				content.style.maxHeight = null;
			}
		}
	});
};

// Le script est chargé avec defer, donc le DOM est déjà chargé
// On peut appeler directement la fonction
handleFooterDropdown();

window.addEventListener('resize', handleFooterDropdown);